import React, { useState, useEffect } from "react"
import { useSelector, useDispatch } from "react-redux"

import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap"
import Select from "react-select"
import { mapApiArrayData } from "helpers/helpers"
import { assignMarkets } from "store/Sports/actions"
import { setSportMarkets } from "helpers/repository"
import { showMessage } from "components/Common/Toaster"
import _ from "lodash"

const MarketDetailsModal = props => {
  const { isOpen, toggle, sportList, setSportList, detailsModal } = props

  // const markets = useSelector(state => state.markets.Index ?? [])
  const [list, setList] = useState([])
  const dispatch = useDispatch()

  const handleSave = () => {
    // let marketIds = list.map(item => item.value)
    // dispatch(assignMarkets({ markets: marketIds }, sportList.sportId, toggle))
    setSportMarkets(
      sportList.id,
      {
        market_ids: list.map(l => l.value),
      },
      saveSuccess,
      saveError
    )
  }
  const saveSuccess = () => {
    showMessage("success", "Updated Successfully")
    props.getSports()
    props.setdetailsModal(false)
  }

  const saveError = () => {
    showMessage("success", "Something went wrong")
  }
  const handleChange = fullList => {
    setList(fullList)
  }

  useEffect(() => {
    let sport_markets = sportList?.markets ?? []
    sport_markets = _.sortBy(sport_markets, "pivot.id")
    setList(
      sport_markets?.map(m => {
        return {
          label: m.name,
          value: m.bb_id,
        }
      })
    )
  }, [sportList])
  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>Assigned Markets</ModalHeader>
        <ModalBody>
          <p className="mb-2">
            <span className="" style={{ fontWeight: "bold" }}>
              Sport Name: &nbsp;
            </span>
            <span className="">{sportList.name}</span>
          </p>
          <div className="mb-3">
            <label className="control-label" style={{ fontWeight: "bold" }}>
              Assign New Market:
            </label>
            <Select
              value={list?.map(item => {
                return {
                  label: item.label,
                  value: item.value,
                }
              })}
              maxMenuHeight={150}
              isMulti={true}
              onChange={item => {
                handleChange(item)
              }}
              options={props.markets.map(market => {
                return {
                  label: market.name,
                  value: market.bb_id,
                }
              })}
              classNamePrefix="select2-selection"
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="secondary" onClick={toggle}>
            Close
          </Button>
          <Button type="button" color="success" onClick={handleSave}>
            Save
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  )
}

export default MarketDetailsModal
